import { createFileRoute } from '@tanstack/react-router'
import { AdminIntegrations } from '../features/admin'
import { integrationsQuery } from '../features/admin/queries'
import { adminRouteState } from '../features/admin/route-state'

export const Route = createFileRoute('/admin/integrations')({
  ...adminRouteState,
  loader: ({ context }) => context.queryClient.ensureQueryData(integrationsQuery()),
  component: AdminIntegrations,
})
